import React from 'react'
import PropTypes from 'prop-types'
import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Button as BaseButton } from 'antd-mobile'

export default class Button extends React.Component {
  render() {
    const { intl, name = 'submit', size, children, className, ...restProps } = this.props
    var defaultClassName = classes.componentsButton
    if (size) {
      defaultClassName += ` am-button-${size}`
    }

    if (className) {
      defaultClassName += ` ${className}`
    }

    if (restProps.type === 'light') {
      restProps.className = 'am-button-light'
    }

    if (restProps.type === 'add') {
      restProps.className = 'am-button-add text-left am-button-xl'
      return (
        <BaseButton {...restProps}>
          <span className='iconfont iconplus font-md' />
          <span>
            <FormattedMessage {...messages[name]} />
          </span>
          <span className='iconfont iconarrow-right-small pull-right gray' />
        </BaseButton>
      )
    }

    return (
      <BaseButton className={defaultClassName} {...restProps}>
        {children || <FormattedMessage {...messages[name]} />}
      </BaseButton>
    )
  }
}

Button.propTypes = {
  name: PropTypes.oneOf([
    'custom',
    'submit',
    'confirm',
    'consentAgreementAndPay',
    'done',
    'tryAgain',
    'refresh',
    'finish',
    'reset',
    'ok',
    'pay',
    'add',
    'addBankAccount',
    'addNewCard',
    'send',
    'resend',
  ]).isRequired,
}
